import { render, staticRenderFns } from "./CeisaPpjkDetail.vue?vue&type=template&id=08730aa3&scoped=true&"
import script from "./CeisaPpjkDetail.vue?vue&type=script&lang=js&"
export * from "./CeisaPpjkDetail.vue?vue&type=script&lang=js&"
import style0 from "./CeisaPpjkDetail.vue?vue&type=style&index=0&id=08730aa3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08730aa3",
  null
  
)

export default component.exports